export class Photo {
  constructor(id = '', name = '', captions = []) {
    this.id = id;
    this.name = name;
    this.captions = captions;
  }
}

export default Photo;




// WEBPACK FOOTER //
// ./src/models/photo.js